import { createStore, compose, applyMiddleware } from 'redux';
import root from './rootReducers';
import thunk from 'redux-thunk';
import { devToolsEnhancer } from 'redux-devtools-extension';
//const store = createStore(
//    root,
//    compose(applyMiddleware(thunk))
//);

//export default store;

//let composeEnhancers;
//if (process.env.NODE_ENV === 'production')
//    composeEnhancers = compose;
//else
//    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//export default compose(applyMiddleware(thunk))(createStore)(root);
export default compose(applyMiddleware(thunk),devToolsEnhancer())(createStore)(root);
